import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicationUser } from '../models/classes/users/ApplicationUser';
import { HttpClient } from '@angular/common/http';

/**
 * The http service injection token.
 */
export const HTTP_SERVICE = new InjectionToken<HttpClient>('HTTP_SERVICE');